import onReady from '@/scripts/modules/on-ready';

onReady( () => {
	const header = document.querySelector( '.single-program .activity-header' );
	const admissionBar = document.querySelector( '.program-admission-bar' );
	const footer = document.querySelector( '.site-footer' );

	if ( ! header || ! admissionBar ) {
		return;
	}

	const mobileMediaQuery = window.matchMedia( '(max-width: 599.98px)' );

	const updateAdmissionBar = () => {
		const headerHasPassed = header.getBoundingClientRect().bottom <= 0;
		const footerRect = footer?.getBoundingClientRect();
		const footerIsVisible = footerRect && footerRect.top < window.innerHeight && footerRect.bottom > 0;
		const isVisible = mobileMediaQuery.matches && headerHasPassed && ! footerIsVisible;

		admissionBar.classList.toggle( 'is-visible', isVisible );
		admissionBar.setAttribute( 'aria-hidden', String( ! isVisible ) );
	};

	const observer = new IntersectionObserver( updateAdmissionBar );
	observer.observe( header );
	if ( footer ) {
		observer.observe( footer );
	}
	mobileMediaQuery.addEventListener( 'change', updateAdmissionBar );
	updateAdmissionBar();
} );
